import React from "react"

const PrimaryButton = ({
  children,
  onClick,
  type = "button",
  icon = null,
  style = {},
  disabled = false,
  ...rest
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        padding: "15px 65px",
        backgroundColor: "#2990DF",
        color: "white",
        border: "none",
        borderRadius: "4px",
        cursor: disabled ? "not-allowed" : "pointer",
        fontWeight: "400",
        fontSize: "1rem",
        fontFamily: "Inter",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        opacity: disabled ? 0.5 : 1,
        ...style,
      }}
      {...rest}
    >
      {children}
      {icon && <span>{icon}</span>}
    </button>
  )
}

export default PrimaryButton
